var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"error-message-container py-15 d-flex justify-center align-center flex-column"},[_c('div',{staticClass:"error-message-content py-5 px-5"},[_c('h2',{staticClass:"title"},[_vm._v("Dashboard")])])])}
var staticRenderFns = []

export { render, staticRenderFns }